import { AppConfigurationKey } from '../../model/enums/appConfigurationKey'
import { User } from '../../model/RBAC'
import { GlobalerisClientModel } from '../../pages/tasks/tasks.model'
import { getAppConfigurationValue } from '../../redux'
import AxiosInstance from '../http-config'

export class ApiRBAC {
  apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  fetch = async (): Promise<User> => {
    return await AxiosInstance.get(`${this.apiSuffixUrl}/api/me`).then(response => {
      return response.data
    })
  }
}

export const apiFetchGlobalerisClientFromDomain = async (
  domain: string
): Promise<GlobalerisClientModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Clients/domain/${domain}`).then(
    response => response.data
  )
}

export const apiFetchUsersFromGlobalerisClient = async (clientId: number): Promise<string[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/AdminUsers/users/${clientId}`).then(
    response => response.data
  )
}
